import { ActionContext, ActionTree, Commit } from "vuex";

import {IState, IRootState,  currentModelId, modelIsActive, activeUser } from "./state-types";

import { IUserAccount } from "../userAccount";

import { FetchWrapper } from "../fetch-wrapper";

export const actions: ActionTree<IState, IRootState> = {

    setCurrentModelId(store: ActionContext<IState, any>, modelId: string) {
        store.commit('setCurrentModelId', modelId);
    },

    setCurrentNodePath(store: ActionContext<IState, any>, nodePath: string) {
        store.commit('setCurrentNodePath', nodePath);
    },

    setNodeModifiedNotification(store: ActionContext<IState, any>, nodePath: string) {
        store.commit('setNodeModifiedNotification', nodePath);
    },

    async fetchData({ commit }): Promise<any> {


        const response = await FetchWrapper.fetch("/accounts/getactiveuser", { method: "get" });
        const response_2 = await response.json();
        const payload: IUserAccount = response_2;
        commit("profileLoaded", payload);
        FetchWrapper.fetch("/api/1.0/query/getUserCapabilities", { method: "get" })
            .then(response_3 => response_3.json())
            .then(response_5 => {

                const payload_1: { capabilities: string[]; } = response_5;
                commit("setCapabilities", payload_1.capabilities);
            });
    }
}



//// ActionTree<[current state], [root state]>
//const actions: ActionTree<State, State> = {
//    updateCurrentModelId({ commit }: ActionContext<State, State>, newModelId: string): void {
//        commit(currentModelId, newModelId);
//    },

//    updateModelIsActive({ commit }: ActionContext<State, State>, newVal: boolean): void {
//        commit(modelIsActive, newVal);
//    },

//    updateActiveUser({ commit }: ActionContext<State, State>, newVal: IUserAccount): void {
//        commit(activeUser, newVal);
//    },

//};

//export default actions;


// WEBPACK FOOTER //
// ./ClientApp/infrastructure/state/state-actions.ts